<template>
  <el-card>
    <el-row>
      <el-form :model="form" ref="query" :inline="true">
        <el-row>
          <el-form-item :label="$t('orders.label.form.submitTime')">
            <range-date-picker ref="datePick" @showDateTime="handleShowTime" />
          </el-form-item>
          <el-form-item :label="$t('orders.label.table.payoutTime')">
            <range-date-picker ref="payOutPick" @showDateTime="handlePayOutTime" :needInit="false"/>
          </el-form-item>

<!--          <el-date-picker type="datetime" size="small" v-model="form.payoutTimeStart" value-format="yyyy-MM-dd HH:mm:ss" />-->
<!--          <span>~</span>-->
<!--          <el-date-picker type="datetime" size="small" v-model="form.payoutTimeEnd" value-format="yyyy-MM-dd HH:mm:ss" />-->
<!--          <el-button-->
<!--            size="mini"-->
<!--            type="primary"-->
<!--            v-for="(btn, key) in btnsTime"-->
<!--            :key="key + Math.random()"-->
<!--            @click="handleTime(key, 'submit')"-->
<!--            round>{{ btn }}-->
<!--          </el-button>-->
          <el-form-item :label="$t('orders.label.form.merchatNo')">
            <el-input size="small" v-model="form.query.merchantNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('usdt.label.agentNo')">
            <el-input size="small" v-model="form.query.agentNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('orders.label.form.systemOrderNo')">
            <el-input size="small" v-model="form.query.systemOrderNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('wallet.label.merchatOrderNo')">
            <el-input size="small" v-model="form.query.merchatOrderNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('usdt.label.wallet')">
            <el-input size="small" v-model="form.query.payAddress"></el-input>
          </el-form-item>
          <el-form-item :label="$t('orders.label.form.callbackStatus')">
            <el-select size="small" v-model="form.query.callbackStatus">
              <el-option
                v-for="item in statusData.callbackStatus"
                :key="item.label"
                :label="item.label"
                :value="item.val"></el-option>
              <el-option :label="$t('btns.emptyValue')" value=""></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('orders.label.form.orderStatus')">
            <el-select size="small" v-model="form.query.orderStatus">
              <el-option
                v-for="item in statusData.orderStatus"
                :key="item.label"
                :label="item.label"
                :value="item.val"></el-option>
              <el-option :label="$t('btns.emptyValue')" value=""></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="mini" type="success" @click="handleEmpty()">{{ $t("btns.empty") }}</el-button>
            <el-button size="mini" type="primary" @click="getOrderList()">{{ $t("btns.search") }}</el-button>
          </el-form-item>
        </el-row>
      </el-form>
    </el-row>
    <el-row>
      <div class="header-table">
        <ul class="list-table">
          <li class="li-table">
            <em class="label">
              <span>
                {{ $t("orders.label.list.totalNumber") }}
              </span>
              <span>：</span>
            </em>
            <span class="value">
              {{ totalData.orderNumberTotal | toThousands }}
            </span>
          </li>
          <li class="li-table">
            <em class="label">
              <span>
                {{ $t("orders.label.list.totalSuccessMoney") }}
              </span>
              <span>：</span>
            </em>
            <span class="value">
              {{ totalData.paymentAmountTotal | toThousands }}
            </span>
          </li>
          <li class="li-table">
            <em class="label">
              <span>
                {{ $t("orders.label.list.totalMoney") }}
              </span>
              <span>：</span>
            </em>
            <span class="value">
              {{ totalData.actualAmountTotal | toThousands }}
            </span>
          </li>
          <li class="li-table">
            <em class="label">
              <span>
                {{ $t("orders.label.list.totalfee") }}
              </span>
              <span>：</span>
            </em>
            <span class="value">
              {{ totalData.handlingFeeTatal | toThousands }}
            </span>
          </li>
        </ul>
        <el-button v-if="tableData && tableData.rows > 0" @click="handleExport()">{{ $t("btns.export") }}</el-button>
      </div>
      <el-table
        :data="tableList"
        stripe
        class="table"
        ref="tableList"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ textAlign: 'center' }">
        <!-- <el-table-column type="index" label="#"></el-table-column> -->
        <el-table-column width="140" :label="$t('clientmanage.table.merchantNo')" prop="merchantNo">
            
        </el-table-column>
        <el-table-column width="90" :label="$t('clientmanage.table.merchantName')" prop="merchantName"></el-table-column>
        <!-- <el-table-column :label="$t('usdt.label.agentNo')" prop="agentNo"></el-table-column> -->
        <el-table-column class-name="status-omit-colum"  width="120px" prop="systemOrderNo" :label="$t('orders.label.table.systemOrderNo')">
          <template slot-scope="{ row }">
            <i
              :title="$t('onlinememberdrawal.copy')"
              class="fa fa-clipboard"
              style="color: #777; cursor: pointer"
              @click="copyText(row.systemOrderNo)"
              ></i>
            <router-link v-if="userType === 0"
                :to="{ name: 'transactionRecord', query: { systemOrderNo: row.systemOrderNo } }">
                {{ row.systemOrderNo }}
            </router-link>
            <span v-else>
                {{ row.systemOrderNo }}
            </span>
        </template>
        </el-table-column>
        <el-table-column class-name="status-omit-colum"  width="120px" :label="$t('wallet.label.merchatOrderNo')" prop="merchatOrderNo">
          <template slot-scope="{ row }">
            <i
            :title="$t('onlinememberdrawal.copy')"
            class="fa fa-clipboard"
            style="color: #777; cursor: pointer"
            @click="copyText(row.merchatOrderNo)"
            ></i>
            {{ row.merchatOrderNo }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('orders.label.table.channelType')" prop="channel"></el-table-column>
        <!-- <el-table-column :label="$t('usdt.label.blockchain')" prop="linkType">
          <template slot-scope="{ row }">
            <span>{{ row.linkType == 1 ? "ERC20" : "TRC20" }}</span>
          </template>
        </el-table-column> -->
        <el-table-column :label="$t('usdt.label.submitVndAmount')" prop="submitVndAmount">
          <template slot-scope="{ row }">{{ row.submitVndAmount | toThousands }}</template>
        </el-table-column>
        <el-table-column :label="$t('usdt.label.exchangeRate')" prop="exchangeRate"></el-table-column>
        <el-table-column :label="$t('usdt.label.submitAmount')" prop="submitAmount">
          <template slot-scope="{ row }">{{ row.submitAmount | toThousands }}</template>
        </el-table-column>
        
        <el-table-column prop="paymentAmount" :label="$t('orders.label.table.paymentAmount')">
          <template slot-scope="{ row }">{{ row.paymentAmount | toThousands }}</template>
        </el-table-column>
        <!-- <el-table-column prop="agentFee" :label="$t('orders.label.table.handlingFee')">
          <template slot-scope="{ row }">{{ row.agentFee | toThousands }}</template>
        </el-table-column> -->
        <el-table-column prop="usdtFee" :label="$t('usdt.label.usdtFee')">
          <template slot-scope="{ row }">{{ row.usdtFee | toThousands }}</template>
        </el-table-column>
        <el-table-column prop="usdtAmount" :label="$t('usdt.label.usdtAmount')">
          <template slot-scope="{ row }">{{ row.usdtAmount | toThousands }}</template>
        </el-table-column>
        <el-table-column prop="successAmount" :label="$t('usdt.label.successAmount')">
          <template slot-scope="{ row }">{{ row.successAmount | toThousands }}</template>
        </el-table-column>
        <el-table-column :label="$t('usdt.label.blockchain')" prop="linkType">
          <template slot-scope="{ row }">
            <span>{{ row.linkType == 1 ? "ERC20" : "TRC20" }}</span>
          </template>
        </el-table-column>
        <el-table-column class-name="status-omit-colum"  width="120px" :label="$t('usdt.label.wallet')" prop="payAddress">
          <template slot-scope="{ row }">
            <i
            :title="$t('onlinememberdrawal.copy')"
            class="fa fa-clipboard"
            style="color: #777; cursor: pointer"
            @click="copyText(row.payAddress)"
            ></i>
            {{ row.payAddress }}
          </template>
        </el-table-column>
        <el-table-column prop="patcher" :label="$t('orders.label.table.patcher')"></el-table-column>
        <el-table-column prop="submitTime" align="center" :label="$t('channel.label.createTime')"></el-table-column>
        <el-table-column prop="payoutTime" :label="$t('orders.label.table.payoutTime')">
          <template slot-scope="{ row }">
            {{ row.payoutTime | asDayjs }}
          </template>
        </el-table-column>
        <el-table-column prop="callbackStatus" :label="$t('orders.label.table.callbackStatus')" width="100">
          <template slot-scope="{ row }">
            <template v-if="statusData.callbackStatus.length">
              <template v-for="item in statusData.callbackStatus">
                <el-tag :key="item.label" :type="item.type" v-if="row.callbackStatus == item.val">
                  <span>{{ item.label }}</span>
                </el-tag>
              </template>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="orderStatus" :label="$t('orders.label.table.orderStatus')" width="100">
          <template slot-scope="{ row }">
            <template v-for="item in statusData.orderStatus">
              <el-tag :key="item.label" :type="item.type" v-if="row.orderStatus === item.val">
                <span>{{ item.label }}</span>
              </el-tag>
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="$t('rolemanager.Remarks')" prop="remark"></el-table-column>
        <el-table-column :label="$t('accountmanager.operation')" v-show="canOperate">
          <template slot-scope="scope">
            <el-popconfirm
              v-if="permission.indexOf('merchant:usdt:manual:callback') != -1"
              :title="$t('orders.tip.danger')"
              :ref="`popover-${scope.row.id}-1`"
              @confirm="getCallback(scope.row)"
              :key="`${scope.row.id}-1`">
              <el-button
                size="mini"
                type="primary"
                slot="reference"
                v-if="(scope.row.orderStatus == 1 || scope.row.orderStatus == 2) && scope.row.callbackStatus != 1">
                {{ $t("btns.callback") }}
              </el-button>
            </el-popconfirm>
            <el-popconfirm
              v-if="permission.indexOf('merchant:usdt:manual:makeup') != -1"
              :title="$t('orders.tip.danger')"
              :ref="`popover-${scope.row.id}-2`"
              @confirm="getManual(scope.row)"
              :key="`${scope.row.id}-2`">
              <el-button
                size="mini"
                type="danger"
                slot="reference"
                v-if="scope.row.orderStatus != 1 && scope.row.orderStatus != 2">
                {{ $t("btns.manual") }}
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <v-pagination v-model="form" :total="tableData.rows" @update="getOrderList" />
  </el-card>
</template>

<script>
import usdtApi from "../../api/usdt";
import { mapGetters } from "vuex";
import moment from "moment";
import RangeDatePicker from "../cuscom/range-date-picker.vue";
import base from "@/mixin/base.js"
export default {
  mixins: [base],
  name: "USDTOrderManage",
  components: {RangeDatePicker},
  data() {
    return {
      submitTimes: [],
      paymentTimes: [],
      form: {
        no: 1,
        size: this.$defaultPaginationSize,
        query: {
          merchantNo: "",
          agentNo: "",
          systemOrderNo: "",
          merchatOrderNo: "",
          submitTimeStart: "",
          submitTimeEnd: "",
          payoutTimeStart: "",
          payoutTimeEnd: "",
          orderStatus: null,
          callbackStatus: null,
          payAddress: null
        }
      },
      tableList: [],
      tableData: {},
      canOperate: false,
      totalData: {}
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    userType() {
          return this.$store.state.user.userType;
      },
    statusData() {
      return {
        patchType: [
          {
            val: -1,
            type: "danger",

            label: this.$t("status.error8")
          },
          {
            val: 0,
            type: "danger",
            label: this.$t("status.error9")
          },
          {
            val: 1,
            type: "danger",

            label: this.$t("status.error10")
          }
        ],
        patchStatus: [
          {
            val: -1,
            type: "danger",

            label: this.$t("status.error7")
          },
          {
            val: 0,
            type: "success",

            label: this.$t("status.success6")
          },
          {
            val: 1,
            type: "danger",

            label: this.$t("status.error8")
          },
          {
            val: 2,
            type: "info",

            label: this.$t("status.doing3")
          }
        ],
        callbackStatus: [
          {
            val: -1,
            type: "danger",
            label: this.$t("status.error5")
          },
          {
            val: 0,
            type: "info",
            label: this.$t("status.error4")
          },
          {
            val: 1,
            type: "success",
            label: this.$t("status.success4")
          }
        ],
        orderStatus: [
          {
            val: -9,
            type: "info",
            label: this.$t("status.error11")
          },
          {
            val: -1,
            type: "danger",
            label: this.$t("status.error6")
          },
          {
            val: 1,
            type: "success",
            label: this.$t("status.success5")
          },
          {
            val: 0,
            type: "info",
            label: this.$t("status.doing2")
          },
          {
            val: 2,
            type: "success",
            label: this.$t("status.success6")
          }
        ]
      };
    },
    btnsTime() {
      return this.$t("orders.btns");
    }
  },
  mounted() {
    this.paymentTimes = ['', ''];
    this.getOrderList();
    this.permission.map((item) => {
      if ("manual:usdt".indexOf(item) != -1) {
        this.canOperate = true;
      }
    });
    this.handleTime();
  },
  methods: {
    handleShowTime(val){
      this.submitTimes = val
    },
    handlePayOutTime(val){
      this.paymentTimes = val
    },
    async getOrderList() {
      const [submitTimeStart, submitTimeEnd] = this.submitTimes;
      const [payoutTimeStart, payoutTimeEnd] = this.paymentTimes;
      this.form.query.payoutTimeEnd = payoutTimeEnd;
      this.form.query.payoutTimeStart = payoutTimeStart;
      this.form.query.submitTimeStart = submitTimeStart;
      this.form.query.submitTimeEnd = submitTimeEnd;
      const { data } = await usdtApi.getUSDTOrders({ data: this.form });
      if (data) {
        if (data.code == 200) {
          this.tableData = data.data
          this.tableList = data.data.list;
          this.getOrderListCount();
        } else {
          this.$message.error(this.$t("status.error"));
        }
      }
    },
    getOrderListCount() {
      usdtApi.countUSDTOrders(this.form.query).then(res => {
        if (res.data.code == 200) {
          this.totalData = res.data.data;
        } else {
          this.$message.error(this.$t("status.error"));
        }
      });
    },
    handleCopy({payAddress}){
        navigator.clipboard
          .writeText(payAddress)
          .then(() => {
            this.$message.success(this.$t('channelTest.copy'));
          })
          .catch(() => {
            this.$message.error(this.$t('status.error'));
          });
    },
    async getCallback(row) {
      const Code = await this.promptGoogleCode();
      if (!Code) return;
      const { data } = await usdtApi.callbackOrder({
        systemOrderNo: row.systemOrderNo,
        patchGoogleCode: Code.value
      });
      if (data) {
        if (data.code === 200) {
          this.$message.success(this.$t("status.success"));
          this.getOrderList();
        } else {
          this.$message.error(data.msg);
        }
      }
    },
    async getManual({ systemOrderNo }) {
      const Code = await this.promptGoogleCode();
      if (!Code) return;
      const { data } = await usdtApi.makeupOrder({
        systemOrderNo,
        patchGoogleCode: Code.value
      });
      if (data) {
        if (data.code === 200) {
          this.$message.success(this.$t("status.success"));
          this.getTableData();
        } else {
          this.$message.error(data.msg);
        }
      }
    },
    handleEmpty() {
      this.form.query = {
        merchantNo: "",
        agentNo: "",
        systemOrderNo: "",
        merchatOrderNo: "",
        submitTimeStart: "",
        submitTimeEnd: "",
        payoutTimeStart: "",
        payoutTimeEnd: "",
        orderStatus: null,
        callbackStatus: null,
        payAddress: null
      };
      this.$refs.datePick.handleTime()
      this.$refs.payOutPick.handleTime()
    },
    handleTime(type = "") {
      const date = new Date();
      // 当天零点
      const zeroTime = new Date(date.toLocaleDateString()).getTime();
      // 当年
      const nowY = date.getFullYear();
      // 当月
      const nowM = date.getMonth();
      // 当月第一天
      const firstDayNow = new Date(nowY, nowM, 1);
      // 上月第一天
      const firstDayNow1 = new Date(nowY, nowM - 1, 1);
      let start = "";
      let end = "";
      let tempDay = '';
      switch (type) {
        case "today":
          start = this.timestamp(zeroTime);
          end = this.timestamp(zeroTime + 24 * 60 * 60 * 1000 - 1);
          break;
        case "yesterday":
          if (this.form.payoutTimeStart) {
            tempDay = new Date(new Date(this.form.payoutTimeStart).toLocaleDateString()).getTime();
            start = this.timestamp(tempDay - 60 * 60 * 24 * 1000);
            end = this.timestamp(tempDay - 1);
          } else {
            start = this.timestamp(zeroTime - 60 * 60 * 24 * 1000);
            end = this.timestamp(new Date(new Date().toLocaleDateString()).getTime() - 1);
          }
          break;
        case "month":
          start = this.timestamp(firstDayNow);
          end = this.timestamp(zeroTime + 24 * 60 * 60 * 1000 - 1);
          break;
        case "lastMonth":
          start = this.timestamp(firstDayNow1);
          end = this.timestamp(new Date(firstDayNow).getTime() - 1);
          break;
        default:
          break;
      }
      this.form.query.payoutTimeStart = start,
        this.form.query.payoutTimeEnd = end;
    },
    timestamp(time) {
      return moment(time).format("YYYY-MM-DD HH:mm:ss");
    },
    async handleExport() {
      const { data } = await usdtApi.exportOrder(this.form.query);
      if (data) {
        const BLOB = data;
        const fileReader = new FileReader();
        fileReader.readAsDataURL(BLOB);
        fileReader.onload = (event) => {
          let a = document.createElement("a");
          a.download = `USDT-Orders-${Number(new Date())}.xlsx`;
          a.href = event.target.result;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        };
      } else {
        this.$message.error(this.$t("status.error"));
      }
    },
  }
};
</script>

<style lang="scss" scoped>
/deep/ .el-table .el-button{
  display: block;
}
.header-table {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(0, 0, 0, 0.2);
  padding-right: 10px;
}

.header-table .list-table {
  display: flex;
  list-style: none;
}

.header-table .list-table li {
  display: flex;
  list-style: none;
}

.header-table .list-table li .label {
  font-style: normal;
}

.header-table .list-table li .value {
  display: flex;
  list-style: none;
}

.header-table .list-table li:nth-child(n + 2) {
  margin-left: 30px;
}

.header-table .btn-table {
  margin-left: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/usdt/index.vue